<template>
  <div>
    <base-header id="status-header" type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row">
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('0', $event)">
          <stats-card
            title="Total"
            type="gradient-red"
            :sub-title="totalApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('1', $event)">
          <stats-card
            title="Unprocessed"
            type="gradient-orange"
            :sub-title="totalUnprocessedApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('2', $event)">
          <stats-card
            title="Processing & Interview"
            type="gradient-red"
            :sub-title="totalProcessingApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('11', $event)">
          <stats-card
            title="Offerred"
            type="gradient-orange"
            :sub-title="totalOfferredApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('10', $event)">
          <stats-card
            title="Accepted"
            type="gradient-orange"
            :sub-title="totalAcceptedApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('8', $event)">
          <stats-card
            title="Rejected/Cancelled"
            type="gradient-orange"
            :sub-title="totalRejectedApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('12', $event)">
          <stats-card
            title="Not Suitable"
            type="gradient-orange"
            :sub-title="totalNotSuitableApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('7', $event)">
          <stats-card
            title="Decline The Invitation By Candidate"
            type="gradient-orange"
            :sub-title="totalDeclinedInvitationByCandidateApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="status-col col-xl-2 col-lg-4 mb-2" @click="showTable('3', $event)">
          <stats-card
            title="Awaiting Response"
            type="gradient-orange"
            :sub-title="totalAwaitingResponseApplications"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <job-applications-table :status="tableJobStatus"></job-applications-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JobApplicationsTable from "./Tables/JobApplicationsTable";
export default {
  name: "tables",
  components: {
    JobApplicationsTable
  },
  data() {
    return {
      totalApplications: "0",
      totalUnprocessedApplications: "0",
      totalProcessingApplications: "0",
      totalOfferredApplications: "0",
      totalAcceptedApplications: "0",
      totalRejectedApplications: "0",
      totalNotSuitableApplications: "0",
      totalDeclinedInvitationByCandidateApplications: "0",
      totalAwaitingResponseApplications: "0",
      tableJobStatus: "0"
    };
  },
  mounted() {
    this.getTotalJobApplicationByStatus(0);
    this.getTotalJobApplicationByStatus(1);
    this.getTotalJobApplicationByStatus(2);
    this.getTotalJobApplicationByStatus(11);
    this.getTotalJobApplicationByStatus(10);
    this.getTotalJobApplicationByStatus(8);
    this.getTotalJobApplicationByStatus(12);
    this.getTotalJobApplicationByStatus(7);
    this.getTotalJobApplicationByStatus(3);
  },
  methods: {
    showTable(status, event) {
      this.$router.push({ query: { page: 1 } });
      this.tableJobStatus = status;

      var statusCards = $(event.target)
        .closest("#status-header")
        .find("div.card");
      for (var i = 0; i < statusCards.length; i++) {
        $(statusCards[i]).removeClass("bg-yellow");
      }

      $(event.target)
        .closest("div.card")
        .addClass("bg-yellow");
    },

    getTotalJobApplicationByStatus(status) {
      this.$store
        .dispatch("fetchTotalJobApplicationByStatus", {
          status: status
        })
        .then(response => {
          if (status == 0) {
            this.totalApplications = response.data.toString();
          } else if (status == 1) {
            this.totalUnprocessedApplications = response.data.toString();
          } else if (status == 2) {
            this.totalProcessingApplications = response.data.toString();
          } else if (status == 11) {
            this.totalOfferredApplications = response.data.toString();
          } else if (status == 10) {
            this.totalAcceptedApplications = response.data.toString();
          } else if (status == 8) {
            this.totalRejectedApplications = response.data.toString();
          } else if (status == 12) {
            this.totalNotSuitableApplications = response.data.toString();
          } else if (status == 7) {
            this.totalDeclinedInvitationByCandidateApplications = response.data.toString();
          } else if (status == 3) {
            this.totalAwaitingResponseApplications = response.data.toString();
          }
        });
    }
  }
};
</script>
<style></style>
